(function () {
	const LOG_PREFIX = "[sm_agent.session_control]";

	function safe_redirect(target) {
		if (!target) return null;
		try {
			if (window.frappe && frappe.utils && typeof frappe.utils.sanitise_redirect === "function") {
				return frappe.utils.sanitise_redirect(target) || null;
			}
		} catch (e) {
			console.warn(LOG_PREFIX, "sanitise_redirect failed", e);
		}
		return target;
	}

	function get_redirect_arg() {
		try {
			if (window.frappe && frappe.utils && typeof frappe.utils.get_url_arg === "function") {
				return frappe.utils.get_url_arg("redirect-to") || null;
			}
		} catch (e) {}
		try {
			const params = new URLSearchParams(window.location.search);
			return params.get("redirect-to") || null;
		} catch (e) {
			return null;
		}
	}

	function extract_duplicate_payload(xhr, data) {
		const response = (xhr && xhr.responseJSON) || data || {};
		const payload = response.sm_agent_duplicate_login;
		if (payload && payload.token) {
			return payload;
		}
		return null;
	}

	function redirect_after_login(data) {
		const message = data && data.message ? data.message : data;
		const home_page = (data && data.home_page) || "/app";
		const redirect_to = (data && data.redirect_to) || null;

		if (message !== "Logged In" && message !== "No App") {
			if (window.login && typeof login.set_invalid === "function") {
				login.set_invalid(__("Could not complete login. Please try again."));
			}
			return;
		}

		if (window.login && typeof login.set_status === "function") {
			login.set_status(__("Success"), "green");
		}

		const target =
			safe_redirect(get_redirect_arg()) ||
			safe_redirect(redirect_to) ||
			home_page;

		// Use replace so back-button doesn't return to the login page.
		try {
			window.location.replace(target);
		} catch (e) {
			window.location.href = target;
		}
	}

	function confirm_duplicate_login(payload) {
		const message =
			payload.message ||
			__("You are already signed in on another browser or device. Would you like to sign out of that session and continue here?");

		const proceed = function () {
			if (window.login && typeof login.set_status === "function") {
				login.set_status(__("Signing in..."), "blue");
			}
			frappe.call({
				method: "sm_agent.sm_agent.utils.session_control.confirm_duplicate_login",
				args: { token: payload.token },
				freeze: true,
				callback: function (r) {
					redirect_after_login((r && r.message) || r);
				},
				error: function (r) {
					const response = (r && r.responseJSON) || {};
					let err_msg = __("Could not replace the previous session. Please try again.");
					if (response._server_messages) {
						try {
							const parsed = JSON.parse(response._server_messages || "[]");
							const first = parsed[0] ? JSON.parse(parsed[0]) : null;
							err_msg = (first && first.message) || err_msg;
						} catch (e) {}
					}
					if (window.login && typeof login.set_invalid === "function") {
						login.set_invalid(err_msg);
					}
				},
			});
		};

		const cancel = function () {
			if (window.login && typeof login.set_invalid === "function") {
				login.set_invalid(__("Login cancelled. Your previous session remains active."));
			}
		};

		// frappe.confirm is the preferred UX; fall back to native confirm() if
		// the dialog stack isn't available on this page (defensive).
		if (window.frappe && typeof frappe.confirm === "function") {
			frappe.confirm(message, proceed, cancel);
		} else if (window.confirm(message)) {
			proceed();
		} else {
			cancel();
		}
	}

	function patch_login_handlers() {
		const handlers = window.login && login.login_handlers;
		if (!handlers || handlers.__sm_agent_installed) {
			return false;
		}
		const original_401 = handlers[401];
		handlers[401] = function (xhr, data) {
			const payload = extract_duplicate_payload(xhr, data);
			if (payload && payload.token) {
				confirm_duplicate_login(payload);
				return;
			}
			if (typeof original_401 === "function") {
				return original_401(xhr, data);
			}
		};
		handlers.__sm_agent_installed = true;
		console.log(LOG_PREFIX, "duplicate-login handler installed");
		return true;
	}

	// Frappe v16 inlines `window.login = {}` AFTER our external <script> runs,
	// so a single immediate install loses the race. Poll briefly until the
	// login object exists, then patch. Stop on success, on `login_rendered`,
	// or after a short timeout (login.js never appears => no-op).
	const POLL_INTERVAL_MS = 50;
	const POLL_TIMEOUT_MS = 5000;
	let elapsed = 0;
	const poll = function () {
		if (patch_login_handlers()) return;
		elapsed += POLL_INTERVAL_MS;
		if (elapsed >= POLL_TIMEOUT_MS) {
			console.warn(LOG_PREFIX, "gave up after", POLL_TIMEOUT_MS, "ms — login_handlers never appeared");
			return;
		}
		setTimeout(poll, POLL_INTERVAL_MS);
	};

	if (window.jQuery) {
		$(document).on("login_rendered", patch_login_handlers);
	}
	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", patch_login_handlers);
	}
	poll();
})();
